import {Reducer} from "react";
import {CreateSubscriptionActions, CreateSubscriptionState} from "./types";

export const initialCreateSubscriptionState: CreateSubscriptionState = {
  currentCreateSubscriptionStep: "basicForm",
  apiResponseData: null,
  formData: {
    name: "",
    description: "",
    hideFromProfile: false,
    requestCustomerPhoneNumber: false,
    isUrlRedirect: false,
    url_redirect: null,
    limitUnitsPerTransaction: false,
    enable_currency_conversion: true,
    selected_currencies: [],
    bookingQuestions: [],
    tiers: [
      {
        tierName: "",
        priceType: "paid",
        currencies: [{callPriceCurrency: "NGN", callPrice: 0}],
        billingFrequency: "monthly",
        billingCount: "until_cancel",
        featuresEnabled: false,
        features: [],
        redirectAfterPurchaseEnabled: false,
      },
    ],
  },
};

export const createSubscriptionReducer: Reducer<
  CreateSubscriptionState,
  CreateSubscriptionActions
> = (
  state: CreateSubscriptionState = initialCreateSubscriptionState,
  action: CreateSubscriptionActions
) => {
  if (action.type === "update-create-subscription-form-step") {
    return {...state, currentCreateSubscriptionStep: action.payload};
  }
  if (action.type === "save-create-subscription-api-response") {
    return {...state, apiResponseData: action.payload.apiResponseData};
  }
  if (action.type === "save-create-subscription-form-values") {
    return {
      ...state,
      formData: {...state.formData, ...action.payload},
    };
  }
  if (action.type === "reset-state") {
    return {...initialCreateSubscriptionState};
  }
  return state;
};
